import React, { Component } from "react";
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Table,
} from "reactstrap";
import ConnectorService from '../../services/api/Connector';
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay';
import { Scrollbars } from 'react-custom-scrollbars';
import { CONNECTOR_BASE_URL } from "settings/shared/constants";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import axios from "axios";


class CreateConnection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      connectorDTOS: [],
      connectorTypeList: [],
      connector: [],
      avatarcolor: [
        'Red', 'Purple', '#2F4F2F', 'Blue', 'pink', 'green', '#FF69B4', '#aba9ad', '#f44336', '#9c27b0',
        '#673ab7', '#00bcd4'
      ],
      groupname: [],
      categoryNames: [],
      activename:'all',
      sheight: window.innerHeight

    }
  }
  componentDidMount() {
    this.getCategoryNames();
    // this.GetGroupName();   
    this.GetAllConnector();
    var abackground = this.state.avatarcolor[Math.floor(Math.random() * this.state.avatarcolor.length)];
    this.state.selectedColor = abackground;
  }

  getCategoryNames = () => { 
    const groupAll = [
                { label:'All', value: 'all'}
              ];
    let categoryList = []
    axios.get(CONNECTOR_BASE_URL + "master.json")
    .then(res => {
      this.setState({
        connectorTypeList: res.data
      })
      res.data.map((item, index) => {
        if(item.category != "all") {
          categoryList.push({
            label: item.category.toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' '),
            value: item.category
          })
        }
       
        this.setState({
          categoryNames: [...groupAll, ...categoryList]
        }, () => {
          this.getConnectorTypes('all')
        })
      })
     
    })
  }

  //Get Particular connector templates

getConnectorTypes = (type) => {

  this.setState({
    activename:type
  })

this.state.connectorTypeList.map((item, index)=> {
  if(item.category == type) {
    let connectorType = []
    item.conn_types.map((conn, index) => {
      connectorType.push({
        icon: conn.icon_path +'/icon.png',
        name: conn.connector,
        type: conn.connector,
        value :conn.connector,
        config: conn.config_path,
        category: item.category,
        connectorName: conn.name
      })
      this.setState({
        connector: [...connectorType]
      })
    })
  }
})
}

getConnnectorIcon = (icon_path) => {
return CONNECTOR_BASE_URL + icon_path
}

  GetConnector = (name) => {
    this.setState({
      activename:name,
      connectorDTOS: [],
      loading: true
    })
    if(name === 'All'){
      this.setState({
        loading:true
      })
      this.GetAllConnector();
    }

    ConnectorService.getAllConnectorsByGroupName(name)
      .then((response) => {
        if (response.status === "SUCCESS") {
          this.setState({
            connectorDTOS: response.connectorBaseDTOPage.content,
            loading: false
          })
        } else {
          this.setState({
            connectorDTOS: [],
            loading: false
          })
        }
      }).catch((error) => {
        this.setState({ loading: false });
      })
  }
  //Get All  connector templates
  GetAllConnector = () => {
    this.setState({
      loading: true,
      connectorDTOS: [],
      activename:'All',
    })
    ConnectorService.getAllConnectorBase()
      .then((response) => {
        if (response.status === "SUCCESS") {
          this.setState({
            connectorDTOS: response.connectorBaseDTOPage.content,
            loading: false
          })
        } else {
          this.setState({
            connectorDTOS: [],
            loading: false
          })
        }
      }).catch((error) => {
        this.setState({ loading: false });
      })
  }
  // Edit Connector
  EditConnector = (config_path, name, category, icon_Path, connName) => {
    this.props.history.push({
      pathname: '/integration/ShowConnector',
      state: { config_path:config_path + "/config.json", connectorName: name, mode: "editConnector", connectorCategory: category, iconpath: icon_Path, connName: connName, allConnPath: config_path}
    })
  }
  closeConnector = () => {
    this.props.history.push({
      pathname: '/integration/connectors',
    })
  }
  render() {
    return (
  
        <>
          <PanelHeader
            content={
              <div className="header text-center">

              </div>
            }
          />
          <div className="content">
          <LoadingOverlay
        active={this.state.loading}
        spinner={<ScaleLoader
          height={35}
          width={5}
          radius={2}
          margin={2}
          color={"#123abc"}
          loading={this.state.loading}
        />}
      >
            <Row>
              <Col xs={12} md={12}>
                <Card>
                  <CardHeader>
                    <Row className="align-items-center">
                      <div className="col">
                        <CardTitle tag="h5">Create Connectors</CardTitle>
                      </div>
                      <div className="col text-right">
                          <div onClick={this.closeConnector} style={{ cursor: 'pointer' }}>
                            <span className="close clear-filter">×</span>
                          </div>
                        </div>
                    </Row>

                  </CardHeader>
                  <Scrollbars autoHeight autoHeightMin={750} autoHeightMax={750}>
                    <CardBody className="cardHeight">
                      <div className="carcontent">

                        <Row className="mt-12">
                          <Col className="mb-12 mb-xl-0" xl="2">
                          <h5>Category</h5>
                          <Scrollbars autoHeight autoHeightMin={750} autoHeightMax={750}>                            
                            <Table className="-striped -highlight">
                              {this.state.categoryNames.map((item, index) => (
                                <tbody key={index}>
                                  <tr className="hoverproject">
                                    <td onClick={e => this.getConnectorTypes(item.value)} style={{cursor:'pointer'}} className={this.state.activename === item.value ? "actclass" : ""}>
                                      {/* <Avatar round={true} color={this.state.selectedColor} name={item.label} size="25" /> */}
                                      <i className="fas fa-link" style={{color:'#03a9f4'}}></i>
                                        &nbsp;&nbsp; <b>{item.label}</b>
                                    </td>
                                  </tr>
                                </tbody>
                              ))}
                            </Table>
                            </Scrollbars>
                          </Col>
                          <Col className="mb-12 mb-xl-0" xl="10">
                            <div className="table-responsive">
                            <Col className="mb-12 mb-xl-0" xl="12">
                            <Row className="icon-examples">
                            <Col lg="12" md="12">
                            {/* <b>{this.state.activename}</b> */}
                            </Col>
                            </Row>
                            <Row className="icon-examples" style={{ marginTop: 10 }}>
                                {this.state.connector.map((item, index) => (<Col sm={2} xs={12} className="gridSize_Connector" >
                                  <Col className="text-center" lg="12" md="12">
                                    <div className="grid-Connector card" onClick={e => this.EditConnector(item.config, item.name, item.category, item.icon, item.connectorName)}>
                                      <img src={this.getConnnectorIcon(item.icon)} alt="Connector Image" />
                                      <div className="grid-desc">{item.connectorName}</div>
                                      {/* <div><span className="connector_topic">{item.type}</span></div> */}
                                      {/* <div className="block-with-description"><span title={item.description} style={{ color: 'black' }}>{item.description}</span></div> */}
                                    </div>
                                  </Col>
                                </Col>))}
                                {this.state.connector.length === 0 && <Col>
                                  <div style={{ justifyContent: "center", textAlign: "center" }}>
                                    <span>No Connectors Found</span>
                                  </div>
                                </Col>
                                }
                              </Row>
                           </Col>
                            </div>
                          </Col>
                        </Row>

                      </div>
                    </CardBody>
                  </Scrollbars>
                </Card>
              </Col>
            </Row>
            </LoadingOverlay>

          </div>
        </>
    );
  }
}

export default CreateConnection;

